import { useState, useEffect } from 'react';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import userService from '../../service/user.service';
import useParam from '../../context/ParamContext';

export default function UserReports({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autoCompleteData,
  autoCompleteOptions,
}) {
  const { params } = useParam();
  const { refetchTable, setRefetchTable } = refetch;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const { setSelectedValues } = values;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'nickName', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    userService.getUsers(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'nickName',
      headerName: 'Név',
      type: 'string',
    },
    {
      field: 'userName',
      headerName: 'Felhasználónév',
      type: 'string',
    },
    {
      field: 'pinCode',
      headerName: 'PIN kód',
      type: 'string',
    },
    {
      field: 'roleId',
      headerName: 'Jogosultsági csoport',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.roleList,
      renderCell: (data) => {
        return data.row.roles?.roleName;
      },
    },
    {
      field: 'homePage',
      headerName: 'Kezdőképernyő',
      type: 'singleSelect',
      valueOptions: autoCompleteData,
      renderCell: (data) => {
        return autoCompleteData.find((item) => item.value === data.row.homePage)?.label;
      },
    },
    {
      field: 'color',
      headerName: 'Szín',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => {
        return data.row.color ? (
          <div
            className="rounded-full shadow-[rgba(0,_0,_0,_0.54)_0px_1px_8px] w-[20px] h-[20px] hover:cursor-pointer mt-1"
            style={{ background: data.row.color }}
          />
        ) : (
          ''
        );
      },
    },
    {
      field: 'costPerHour',
      headerName: 'Költség/óra',
      type: 'number',
    },
    {
      field: 'activeId',
      headerName: 'Aktív',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.webUserArchive,
    },
    {
      field: 'email',
      headerName: 'Email',
      type: 'string',
    },
    {
      field: 'phoneNumber',
      headerName: 'Telefonszám',
      type: 'string',
    },
    ...(params.USER_SHOW_NOTIFYONNEWPROJECT_FIELD === 'Y'
      ? [
          {
            field: 'notifyOnNewProject',
            headerName: 'Új projekt felvitelről értesítés küldése',
            type: 'boolean',
          },
        ]
      : []),
    ...(params.USER_SHOW_COMPANYLOCATION_FIELD === 'Y'
      ? [
          {
            field: 'companyLocationId',
            headerName: 'Telephely',
            type: 'singleSelect',
            valueOptions: autoCompleteOptions.companyLocation,
            renderCell: (data) => {
              return autoCompleteOptions.companyLocation.find((item) => item.value === data.row.companyLocationId)
                ?.label;
            },
          },
        ]
      : []),
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.UserReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      getRowId={(row) => row.userId}
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
}
